import React from 'react';
import SearchMainView from '../../LinkApiRouter/views/SearchMain/SearchMain';
export default function SearchMain() {
    return React.createElement(SearchMainView, null);
}
